/*
 * The following cookies are shared across .gitbook.com domain (define in webConfig.content.trackingCookieDomain)
 */

/**
 * Cookie to indicate the current authenticated user and organization.
 * This cookie is stored on the application frontend and written by it.
 *
 * The `sites-session-tracking` service reads it and transfer its value to the `__session` cookie.
 */
export const LOGIN_COOKIE = '__gitbook_login';

/**
 * Profile stored in the login cookie.
 */
export type LoginCookieProfile = {
    userId: string;
    organizationId: string;
};

/**
 * Expiration for the login cookie (in days).
 * The cookie should persist for a week so that analytics can
 * correlate the organization across sessions.
 */
export const LOGIN_COOKIE_EXPIRATION_DAYS = 7;

/**
 * Cookie used to store the whole visitor session.
 * This cookie is shared across a lot of domains for GitBook Open. It can only be written by the `sites-session-tracking` service.
 * It previously only contained the deviceId, but now contains a JSON of `SessionCookieProfile`.
 */
export const VISITORID_COOKIE = '__session';

/**
 * Profile stored in the visitor session cookie.
 */
export type SessionCookieProfile = {
    deviceId: string;
} & (LoginCookieProfile | {});

/**
 * Amplitude cookies also expire after 10 years.
 */
export const SESSION_COOKIE_EXPIRATION_DAYS = 10 * 365;
